{
	"title": "Necesitas iniciar sesión",
	"description": "Para ver esta página, es necesario iniciar sesión. Inicie sesión. Luego, será redirigido a la página solicitada.",
	"primaryButtonTitle": "Abrir inicio de sesión"
}
